<ion-item mode="md" lines="none" color="white" class="ion-text-center">
  <ion-label
    color="tpcta"
    mode="md"
    class="the-existence-prices-products-subject-change"
    [attr.data-test]="'Automation.txt-summary-disclaimer' | translate"
  >
    {{ "Labels.the-existence-prices-products-subject-change" | translate }}
  </ion-label>
</ion-item>
